<div class="container">
    <div class="row justify-content-md-center ">
      <div clas="col col-lg-8">
        <div class="card mb-3">
          <div class="card-header backgroundHeader text-center">
            Mensagem do Sistema
          </div>
          <div class="card-body backgroundBody text-center">
            <p class="card-text"> {{ mensagemErro }} 
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>